import { render, staticRenderFns } from "./PagesComponent.vue?vue&type=template&id=3c5d4afa&scoped=true&"
import script from "./PagesComponent.vue?vue&type=script&lang=js&"
export * from "./PagesComponent.vue?vue&type=script&lang=js&"
import style0 from "./PagesComponent.vue?vue&type=style&index=0&id=3c5d4afa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d4afa",
  null
  
)

export default component.exports